import type { GetUserAccountQuery, UserTraveller } from '@/generated/graphql';

const fillEmailToUserTravellers = (
  travellersData: GetUserAccountQuery
): UserTraveller[] => {
  return travellersData?.userAccount?.userTravellers?.map((traveller) => {
    return {
      ...traveller,
      email: travellersData?.userAccount?.email,
    };
  }) as UserTraveller[];
};

export default fillEmailToUserTravellers;
